<template>
  <b-container fluid>
    <b-row>
      <b-col class="text-center">KeyIngress Integration</b-col>
    </b-row>
    <b-row>
      <b-col cols="4">
        <b-form>
          <b-form-group id="input-group-1" label="Select group to import participants from:" label-for="groupSelect">
            <b-form-select id="groupSelect" v-if="options" v-model="selectedGroup" :options="options">
            </b-form-select>
            <b-spinner v-else-if="!options && !groupFetchError" label="Spinning"></b-spinner>
            <b-button :disabled="selectedGroup===null || importRunning" variant="primary" @click="onImportParticipants">Import</b-button>
            <div>{{groupFetchError}}</div>
          </b-form-group>

          <div v-if="importRunning">Import in progress
            <b-spinner></b-spinner>
          </div>

          <b-form-group v-if="importResult || importRunning" label="Import result">
            <div v-if="importResult && importResult.error">Error: {{importResult.error}}</div>
            <div v-if="importResult && !importResult.error">Successfully imported: {{importResult.nImported}} participants</div>
          </b-form-group>

        </b-form>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="1" v-for="action in actionList" :key="action.extname">
        <b-button variant="primary" @click="onActionClicked(action.extname)">{{action.title}}
          <b-spinner small v-if="runningAction===action.extname"></b-spinner>
        </b-button>
      </b-col>
    </b-row>

    <b-row v-if="actionList.length>0">
      <b-col cols="12">
        <b-textarea v-model="actionResult" disabled></b-textarea>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import KeyIngressService from "@/services/KeyIngressService";

export default {
  name: 'KeyIngressPage',

  data() {
    return {
      selectedGroup: null,
      groupFetchError: null,
      options: null,
      importResult: null,
      importRunning: false,

      runningAction: null,

      actionList: [],

      actionResult: ""
    }
  },

  components: {
    // SettingsComponent
  },

  computed: {
    ...mapState(['activeSurvey', 'absoluteDrillPath', 'userIdentity']),
    ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),

  },

  methods: {
    loadGroupsActions() {
      KeyIngressService.getGroupList(this.authToken, this.realmName, this.studyName).then((response) => {
        this.options = response.data.groups
        this.groupFetchError = response.data.error
      })

      KeyIngressService.getActions(this.authToken, this.realmName, this.studyName).then((response) => {
        this.actionList = response.data
      })

    },

    onImportParticipants(/*dto*/) {
      this.importRunning = true
      this.importResult = null
      KeyIngressService.importSamples(this.authToken, this.realmName, this.studyName, this.selectedGroup).then((response) => {
        this.importResult = response.data
        this.importRunning = false
      })
    },

    onActionClicked(actionName) {
      this.actionResult = '...'
      this.runningAction = actionName;
      KeyIngressService.runAction(this.authToken, this.realmName, this.studyName, actionName).then((response) => {
        this.actionResult = response.data
        this.runningAction = null
      })

    }

  },

  watch: {
    $route: {
      handler() {
        this.loadGroupsActions()
      },
      immediate: true
    },

  }

}
</script>